module.exports = __webpack_public_path__ + "img/SYM04.f4ebca15.gif";